import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { APICreateResponse, APIListResponse } from "@shared/api-client-services/api-responses.interface";
import { ConfigService } from "@shared/services/core/config.service";
import { ManifestGuestGuardianMinorRelationship } from "./rentals-manifest-guest-guardian-minor-standard.client.interface";
import { catchError, map, of, throwError } from "rxjs";

@Injectable({ providedIn: 'root' })
export class RentalsManifestGuestGuardianMinorStandardClientService {
    private env = inject(ConfigService);
	private http = inject(HttpClient);

    getGuardianMinorList(manifestId: number, manifestGuestId: number) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/manifest/${manifestId}/manifest-guest/${manifestGuestId}/guardian-minor`;

        return this.http.get<APIListResponse<ManifestGuestGuardianMinorRelationship>>(url).pipe(map(response => response.items));
    }

    createGuardianMinorRelationship(manifestId: number, guardianManifestGuestId: number, minorManifestGuestId: number) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/manifest/${manifestId}/manifest-guest/${minorManifestGuestId}/guardian-minor`;
        const body = { guardianManifestGuestId };

        return this.http.post<APICreateResponse<null>>(url, body);
    }

    createGuardianMinorRelationshipLegacy(manifestId: number, guardianManifestGuestId: number, minorManifestGuestId: number) {
        const url = `${this.env.get('rentalsApiEndPoint')}/standard/manifest/${manifestId}/manifest-guest/${minorManifestGuestId}/guardian-minor`;
        const body = { guardianManifestGuestId };

        return this.http.post<APICreateResponse<null>>(url, body).pipe(catchError((error) => {
            if (error?.message === 'Cannot create guardian to minor relationship') {
                if (error?.messageDetails?.length === 1) {
                    if (error?.messageDetails[0]?.message === 'This relationship already exists.') {
                        return of({ item: null });
                    }
                }
            }

            return throwError(() => new Error(error));
        }));
    }
}